// opervex-frontend/src/Opervex/Report/GoodsMovement.js

class GoodsMovement {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "operation",
        label: "Operação",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "operationText",
        label: "Texto Operação",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data do documento",
        type: "dateOnly",
        visible: true,
        hidden: false,
      },
      {
        key: "amount",
        label: "Montante",
        type: "currency",
        visible: true,
        hidden: false,
      },
      {
        key: "originDeposit",
        label: "Depósito de origem",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "originDepText",
        label: "Texto do depósito de origem",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "destinationDeposit",
        label: "Depósito de destino",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "destinationDepText",
        label: "Texto do depósito de destino",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "reference",
        label: "Referência",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "accesskey",
        label: "Chave de Acesso",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "createBy",
        label: "Criado por",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "createByName",
        label: "Criado por(Nome)",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "createOn",
        label: "Data de Criação",
        type: "date",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default GoodsMovement;
